export const isProduction = (): boolean => {
    return window.appEnvironment === 'production';
};
